import React, { PropTypes, Component } from 'react';
import UploadBox from '../UploadBox';
import Steps from '../../actions/StepsActionCreator';
import Link from '../Link';

class UploadStep extends Component {
  static propTypes = {
    steps: PropTypes.object
  };

  _changeSvg(data, path) {
    Steps.setUploadData(data, path);
  }

  _submit() {
    Steps.upload();
  }

  render() {
    return (
      <div className="UploadStep">
        <div className="row">
          <div className="col-md-4 small-padding">
            <UploadBox
              uploadData={this.props.steps.uploadData}
              uploadPath={this.props.steps.uploadPath}
              change={this._changeSvg}
              submit={this._submit}
            />

            {this.props.steps.error &&
              <div className="alert alert-danger" role="alert">
                <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                &nbsp;{this.props.steps.errorMessage}
              </div>
            }

            <div className="alert alert-info" role="alert">
              <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
              &nbsp;By clicking the upload button you agree to the following terms:
              <ul>
                <li>Your SVG will be processed and saved on the server for at least one week</li>
                <li>Your generated STL will be saved on the server for at least one week</li>
                <li>Anyone with a link can view both, SVG and STL</li>
                <li><a href="http://www.wtfpl.net/txt/copying/">WTFPL License</a> for all uploaded and generated files</li>
              </ul>
            </div>

          </div>

          <div className="col-md-8 small-padding">
            <div className="alert alert-info">
              <p>SVG 2 STL is an online svg to stl converter. Often it is enough to extrude 2d drawings in order to get a nice 3D printable design. Browse the <a href="/gallery" onClick={Link.handleClick}>Gallery</a> to see what other people converted.</p>
              <h3>Why</h3>
              <p>The conversion from SVG to STL can be frustrating if one does not know the proper tools to use. The aim of this service is to provide a way of simply uploading an SVG and downloading an STL, ready for 3D printing.</p>

              <h3>How</h3>
              <p>The conversion process is split into multiple steps:</p>
              <ul>
                <li><b>Upload:</b> Upload your SVG; behind the scenes your SVG will be cleand, unnesesarry tags will be removed</li>
                <li><b>Convert:</b> Set an extrusion height; on the server your SVG will be converted to a EPS, DXF, SCAD and finally STL</li>
                <li><b>Download:</b> Inspect your generated STL in the viewer and download it</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UploadStep;



/** WEBPACK FOOTER **
 ** ./src/components/UploadStep/UploadStep.js
 **/